// src/slices/collecteurApiSlice.js
import { apiSlice } from "./apiSlice";

const URL = "/api/collecteurs";

export const collecteurApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCollecteurs: builder.query({
      query: () => ({ url: URL }),
      providesTags: ["Collecteur"],
      keepUnusedDataFor: 60,
    }),
    getCollecteurById: builder.query({
      query: (id) => ({ url: `${URL}/${id}` }),
      providesTags: ["Collecteur"],
    }),
    // Positions pour la carte (admin).
    getCollecteurPositions: builder.query({
      query: () => ({ url: `${URL}/positions` }),
      providesTags: ["CollecteurPosition"],
    }),
    getMyCollecteurs: builder.query({
      query: () => ({ url: `${URL}/mine` }),
      providesTags: ["Collecteur"],
    }),
    // Relevé de position envoyé par l'app (agent).
    pingCollecteur: builder.mutation({
      query: (data) => ({ url: `${URL}/ping`, method: "POST", body: data }),
    }),
    requestSonnerie: builder.mutation({
      query: (id) => ({ url: `${URL}/${id}/sonnerie`, method: "POST" }),
    }),
    createCollecteur: builder.mutation({
      query: (data) => ({ url: URL, method: "POST", body: data }),
      invalidatesTags: ["Collecteur"],
    }),
    updateCollecteur: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${URL}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Collecteur"],
    }),
    deleteCollecteur: builder.mutation({
      query: (id) => ({ url: `${URL}/${id}`, method: "DELETE" }),
      invalidatesTags: ["Collecteur"],
    }),
  }),
});

export const {
  useGetCollecteursQuery,
  useGetCollecteurByIdQuery,
  useGetCollecteurPositionsQuery,
  useGetMyCollecteursQuery,
  usePingCollecteurMutation,
  useRequestSonnerieMutation,
  useCreateCollecteurMutation,
  useUpdateCollecteurMutation,
  useDeleteCollecteurMutation,
} = collecteurApiSlice;